module.exports = __webpack_public_path__ + "img/contact_bg.fb1f7101.png";